import React from "react";
import "../style/WhyChoose.css";
import { whyChooseDetails } from "../data/whyChooseData";

const WhyChoose = () => {
  return (
    <section id="why" className="why-choose">
      <div className="section-heading">
        <h2 className="section-title">Why Choose Rammyaa</h2>
        <p className="section-subtitle">
          Premium formulations, transparent ingredients and results our
          customers keep coming back for.
        </p>
      </div>
      <div className="why-choose-grid">
        {whyChooseDetails.map((item) => {
          const Icon = item.icon;
          return (
            <div key={item.id} className="why-choose-card">
              <span className="why-choose-icon-wrap">
                <Icon size="1.5em" />
              </span>
              <h3 className="why-choose-title">{item.title}</h3>
              <p className="why-choose-description">{item.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WhyChoose;
